import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { mapDate } from '../actions/map';
import MapIcon from '@mui/icons-material/Map';
var DayTab = function DayTab(props) {
  var navigate = useNavigate();
  var params = useParams();
  var dispatch = useDispatch();
  var day = props.day,
    option = props.option;
  if (!option) {
    return /*#__PURE__*/React.createElement("div", {
      onClick: function onClick() {
        return navigate({
          pathname: "/".concat(params.type ? params.type : 'scheduled', "/").concat(day)
        });
      },
      className: "header-tab ".concat(params.cat === day ? ' active' : '')
    }, /*#__PURE__*/React.createElement("h3", null, new Intl.DateTimeFormat('en-US', {
      weekday: 'long',
      timeZone: 'UTC'
    }).format(new Date(day))), /*#__PURE__*/React.createElement("p", null, new Intl.DateTimeFormat('en-US', {
      month: 'long',
      day: '2-digit',
      timeZone: 'UTC'
    }).format(new Date(day))), params.cat === day && /*#__PURE__*/React.createElement("button", {
      id: "map-current-date-tab",
      className: "btn",
      onClick: function onClick() {
        return dispatch(mapDate());
      }
    }, /*#__PURE__*/React.createElement(MapIcon, null), /*#__PURE__*/React.createElement("span", null, "MAP")));
  } else {
    return /*#__PURE__*/React.createElement("option", {
      value: day,
      key: "day-option-".concat(day)
    }, new Intl.DateTimeFormat('en-US', {
      weekday: 'long',
      month: 'long',
      day: '2-digit',
      timeZone: 'UTC'
    }).format(new Date(day)));
  }
};
export default DayTab;